import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/marketing-channels')({
	staticData: { crumb: ({ context: { L } }) => L.Marketing.Channel.Title() }
})
